<template>
  <div class="phairify-insights">
    <div class="mt-3">
      <v-wait :for="`${$options.name}_loading`">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Load insights data...
          </div>
        </template>
        <template>
          <b-row class="mb-3">
            <b-col lg="12">
              <div
                class="font-weight-bold v3_color_teal border_bottom_1 border_bottom_light_teal pb-2 font_size_1250rem"
              >
                Market Data
              </div>
            </b-col>
          </b-row>
          <insights-dynamic-section
            v-if="questionnaire.insights_section_content"
            :title="questionnaire.insights_section_title"
            :content="questionnaire.insights_section_content"
          />
          <div class="box-body-color-pedding">
            <div v-if="resultsSorted.length > 0">
              <b-row class="survey-results__results-chart mt-5">
                <b-col
                  class="mb-4"
                  sm="12"
                  :xl="12 / chartsPerRow"
                  v-for="(res, index) in resultsSorted"
                  :key="res.id || index"
                >
                  <div class="mx-auto h-100 shadow-none phairify-chart-card">
                    <div v-if="res && res.chart_title">
                      <h2
                        class="font_Montserrat font_size_1000rem v3_color_black_knight mb-0"
                      >
                        <span>{{ res.chart_title }}</span>
                      </h2>
                    </div>
                    <b-card-body class="px-0">
                      <div v-if="res && res.results && !res.results.length">
                        <b-alert show variant="warning">
                          No results found
                        </b-alert>
                      </div>
                      <div v-else-if="res && res.insufficient">
                        <b-alert show variant="warning">
                          There is not enough data to display
                        </b-alert>
                      </div>
                      <div v-else-if="res">
                        <ChartBuilder
                          :result="res"
                          :format="isStudySubmitted ? 'dashboard' : 'no-study-completed'"
                          :comparison="{}"
                          :is-title-visible="false"
                        />
                      </div>
                    </b-card-body>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-row v-else align-h="center">
              <b-col class="text-center">
                <p class="phairify-insights-warn my-4 phairify-color-darken_red">
                  {{ 'No insights are available for your study.' }}
                </p>
              </b-col>
            </b-row>
          </div>
        </template>
      </v-wait>
    </div>
  </div>
</template>

<script>
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import ChartBuilder from '@/components/survey/results/ChartBuilder';
import InsightsDynamicSection from '@/components/dashboard/InsightsDynamicSection';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'KeyMeasures',
  components: {
    HalfCircleSpinner,
    ChartBuilder,
    InsightsDynamicSection,
  },
  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
    isLandingDashboardPage: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      results: {},
    };
  },
  created: async function () {
    await this.refreshResults();
  },
  computed: {
    resultsSorted: function () {
      let results = Array.isArray(this.results) ? this.results : [];
      // todo: add ordering here when will be implemented
      return results.filter((r) => !!r && !!r.id);
    },
    isQuestionnaireSupportsReports: function () {
      return (
        this.questionnaire &&
        parseInt(this.questionnaire.is_support_report) === 1
      );
    },
    chartsPerRow: function () {
      return this.resultsSorted.length === 1 ? 1 : 2;
    },
    isStudySubmitted: function () {
      return this.questionnaire.survey && this.questionnaire.survey.submitted;
    },
  },
  methods: {
    refreshResults: async function () {
      this.results = [];
      this.$wait.start(`${this.$options.name}_loading`);

      try {
        this.results = this.isLandingDashboardPage
          ? await Api.getSurveyResultsForLandingDashboard()
          : await Api.getSurveyResultsForDashboard(!this.isStudySubmitted);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(`${this.$options.name}_loading`);
      }
    },
    // when we're showing one chart per variable on a question,
    // only give the chart a title if there is > 1 variable
    getVariableChartTitle: function (q, varLabel) {
      if (q && q.question && q.question.variablesCount === 1) {
        return '';
      } else {
        return varLabel;
      }
    },
  },
};
</script>

<style scoped>
.box-body-color-pedding{
  background-color: rgba(2,22,35,0.025);
  padding: 4rem;
}
</style>

<style lang="scss">
@import 'sass/variables_mixins.scss';

.highcharts-title {
  @include phairify_heading_not_bold_14;
}

.survey-results__question-prompt {
  width: calc(100% - 30px);
  @include phairify_heading_not_bold_18;
}
.phairify-insights {
  .my-value__label {
    @include phairify_list_content;
    font-weight: 700;
  }
}
.phairify-chart-card {
  .card-body {
    @include phairify_list_content;
  }
}
.phairify-insights-warn {
  @include phairify_heading_not_bold_14;
}
</style>
